import React, { useEffect } from 'react';
import { useState } from 'react';
import './Header.css';


const Header = () => {
    const hamburger = document.querySelector('.header .nav-bar .nav-list .hamburger');
    const mobile_menu = document.querySelector('.header .nav-bar .nav-list ul');

    const [isClicked, setIsClicked] = useState(false);
    const [headerBg, setHeaderBg] = useState(false);

    useEffect(() => {
        if (isClicked) {
            hamburger.classList.toggle('active');
            mobile_menu.classList.toggle('active');
        }
    }, [isClicked])

    const handleHamburger = () => {
        setIsClicked(!isClicked);
        if (isClicked) {
            hamburger.classList.toggle('active');
            mobile_menu.classList.toggle('active');
        }
    }

    const handleMenuItem = () => {
        setIsClicked(true);
        if (isClicked) {
            hamburger.classList.toggle('active');
            mobile_menu.classList.toggle('active');
        }
    }
    const handleHeaderScroll = () => {
        var scroll_position = window.scrollY;
        if (scroll_position > 250) {
            setHeaderBg(true);
        }
        else {
            setHeaderBg(false);
        }
    }
    useEffect(() => {
        window.addEventListener('scroll', handleHeaderScroll);
    }, [headerBg])

    return (
        <div id="header" >
            <div className={headerBg ? 'header active section-container' : 'header section-container'}>
                <div className="nav-bar">
                    <div className="brand">
                        <a href="#hero">
                            <h1><span>A</span>vijit <span>R</span>oy</h1>
                        </a>
                    </div>
                    <div className="nav-list">
                        <div className="hamburger" onClick={handleHamburger}>
                            <div className="bar"></div>
                        </div>
                        <ul>
                            <li><a onClick={handleMenuItem} href="#hero" data-after="Home">Home</a></li>
                            <li><a onClick={handleMenuItem} href="#about" data-after="About">About Me</a></li>
                            <li><a onClick={handleMenuItem} href="#skills" data-after="Skill">Skills</a></li>
                            <li><a onClick={handleMenuItem} href="#projects" data-after="Projects">Projects</a></li>
                            <li><a onClick={handleMenuItem} href="#blogs" data-after="Blogs">Blogs</a></li>
                            <li><a onClick={handleMenuItem} href="#academic" data-after="Academic">Academic</a></li>
                            <li><a onClick={handleMenuItem} href="#contact" data-after="Contact">Contact Me</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;